import React, { Component } from 'react';
import classNames from 'classnames';
import withStyles from '@mui/styles/withStyles';
import Typography from '@mui/material/Typography';
import { dateToTimeString, dateToDateString } from '../../helpers/dates';
import moment from 'moment';

class Title extends Component {
  airportColor = name => {
    const { airports } = this.props;
    const airport = airports.find(airport => airport.name === name);
    if (airport) return airport.color;
    return 'black';
  };

  getTimeString = timestamp => {
    return `${dateToTimeString(timestamp).toUpperCase()}LT ${dateToDateString(
      timestamp
    ).toUpperCase()}`;
  };

  renderTimeUpdates = () => {
    const { tab, estimatedTime, actualTime, scheduledTime } = this.props;
    let label;
    let timeString;

    if (actualTime && !moment(actualTime).isSame(scheduledTime)) {
      if (tab === 0) {
        label = 'ATA';
      } else {
        label = 'ATD';
      }

      timeString = this.getTimeString(actualTime);
    }

    if (
      estimatedTime &&
      !actualTime &&
      !moment(estimatedTime).isSame(scheduledTime)
    ) {
      if (tab === 0) {
        label = 'ETA';
      } else {
        label = 'ETD';
      }

      timeString = this.getTimeString(estimatedTime);
    }

    return label && timeString ? <div>{`${label} ${timeString}`}</div> : null;
  };

  render() {
    const {
      classes,
      scheduledTime,
      inboundAirport,
      outboundAirport,
      estimatedTime,
      actualTime,
      tab,
    } = this.props;

    return (
      <div className={classes.container}>
        <Typography
          variant="h6"
          className={classes.airport}
          style={{ color: this.airportColor(outboundAirport) }}
        >
          {outboundAirport}
        </Typography>
        <div className={classes.info}>
          <Typography
            variant={
              (estimatedTime && !moment(estimatedTime).isSame(scheduledTime)) ||
              actualTime
                ? 'subtitle2'
                : 'h6'
            }
          >
            <div>
              {tab === 0 ? 'STA' : 'STD'} {this.getTimeString(scheduledTime)}
            </div>
            {this.renderTimeUpdates()}
          </Typography>
        </div>
        <Typography
          variant="h6"
          className={classNames(classes.airport, classes.airportRight)}
          style={{ color: this.airportColor(inboundAirport) }}
        >
          {inboundAirport}
        </Typography>
      </div>
    );
  }
}

const styles = () => ({
  container: {
    display: 'flex',
    width: '100%',
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  airport: {
    flex: '1 0 0',
    display: 'flex',
    alignItems: 'center',
  },
  airportRight: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

export default withStyles(styles)(Title);
